import { Card, CardContent, Box } from "@mui/material";
import type { IThemeState } from "../../../types/theme";

const LivestreamPanel = ({ reduxTheme }: { reduxTheme: IThemeState }) => {
  return (
    <Card
      sx={{
        height: 482,
        backgroundColor: reduxTheme.primary_colors?.[800],
        width: 660,
        pt: 6,
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: 2, height: "100%", overflow: "hidden" }}>
        <Box
          display="flex"
          flexDirection="column"
          gap={1.5}
          sx={{ overflow: "hidden" }}
        ></Box>
      </CardContent>
    </Card>
  );
};

export default LivestreamPanel;
